/*
 * @Author: shannyHuang
 * @Date: 2022-03-24 19:07:20
 * @LastEditors: brucexlliu
 * @LastEditTime: 2023-05-09 15:57:42
 * @FilePath: \wemeet-web-activity\src\components\saleModal\index.tsx
 */
import React, { useCallback } from 'react';
import { Modal, Button, Icon } from '@tencent/tea-component';
import { Dialog } from '@tencent/calendar-web-component-mobile';
import styles from './index.module.scss';
import { render } from 'react-dom';

interface Props {
  visible?: boolean;
  isMobile?: boolean;
  title?: string;
  content?: React.ReactChild;
  cancelTxt?: string;
  okTxt?: string;
  onConfirm?: () => void | Promise<void>;
  onCancel?: () => void | Promise<void>;
  className?: string;
  /** 设置icon的类型，设置为none的话就不展示icon */
  iconType?: string;
  newStyle?: boolean;
}
export default function SaleModal(props: Props) {
  const {
    visible = false,
    title,
    content,
    okTxt,
    cancelTxt,
    iconType = 'warning',
    onConfirm,
    onCancel,
    className,
    newStyle,
  } = props;

  const onClose = useCallback(() => {
    onCancel?.();
  }, [onCancel]);

  const onOk = useCallback(() => {
    onConfirm?.();
  }, [onConfirm]);

  return (
    <Modal
      visible={visible}
      className={`responsive ${className || ''} ${newStyle ? styles.newStyle : ''}`}
      size={'s'}
      caption={
        <p
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {iconType !== 'none' && <Icon type={iconType} size="l" />}
          <span
            style={{
              marginLeft: '8px',
            }}
          >
            {title}
          </span>
        </p>
      }
      onClose={onClose}
    >
      <Modal.Body>
        <p className={iconType !== 'none' ? styles.pindent : ''}>{content}</p>
      </Modal.Body>
      <Modal.Footer>
        {/* 若不传取消按钮内容，则不展示取消按钮 */}
        {cancelTxt && (
          <Button type="weak" onClick={onClose}>
            {cancelTxt ? cancelTxt : '取消'}
          </Button>
        )}
        <Button type="primary" onClick={onOk}>
          {okTxt ? okTxt : '确认'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
SaleModal.close = () => {
  SaleModal.show({ visible: false });
};

SaleModal.show = (props: Props) => {
  const {
    title = '是否确认下架？',
    content = '活动下架后将退回草稿箱。您可以在会议管理后台继续管理对应的会议。',
    okTxt,
    cancelTxt,
    visible = true,
    isMobile = false,
    onConfirm,
    iconType,
    className,
    newStyle,
  } = props;

  if (isMobile) {
    return Dialog.show({
      title,
      content,
      okText: okTxt,
      cancelText: cancelTxt,
      onOk: props.onConfirm,
      onCancel: props.onCancel,
      className,
    });
  }
  let el = document.getElementById('el-sale-modal');
  if (!el) {
    el = document.createElement('div');
    el.id = 'el-sale-modal';
    document.body.appendChild(el);
  }
  // 闭包保存当前的 title/content
  const close = ((props) => () => {
    SaleModal.show({ ...props, visible: false });
  })(props);

  const onOk = () => {
    Promise.resolve(onConfirm?.()).then(close);
  };
  const onCancel = () => {
    Promise.resolve(props?.onCancel?.()).then(close);
  };
  render(
    <SaleModal
      title={title}
      content={content}
      visible={visible}
      okTxt={okTxt}
      cancelTxt={cancelTxt}
      onConfirm={onOk}
      onCancel={onCancel}
      iconType={iconType}
      className={className}
      newStyle={newStyle}
    />,
    el,
  );

  return close;
};
